import { Outlet, useLocation } from 'react-router-dom';
import { AppLayout } from './AppLayout';

export const RootLayout = () => {
  const location = useLocation();
  const isAuthPage = location.pathname === '/login' || location.pathname === '/auth/callback';

  if (isAuthPage) {
    return (
      <div className="min-h-screen w-full">
        <Outlet />
      </div>
    );
  }

  return <AppLayout><Outlet /></AppLayout>;
}; 